import { render, staticRenderFns } from "./jcPage.vue?vue&type=template&id=0dee153f&scoped=true&"
import script from "./jcPage.vue?vue&type=script&lang=js&"
export * from "./jcPage.vue?vue&type=script&lang=js&"
import style0 from "./jcPage.vue?vue&type=style&index=0&id=0dee153f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee153f",
  null
  
)

export default component.exports